// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportManagement-space1-CLnGJ {
	margin-bottom: 6px !important;
}

.ReportManagement-space2-etRMk {
	margin-bottom: 12px !important;
}

.ReportManagement-space3-Ly973 {
	margin-bottom: 18px !important;
}

.ReportManagement-space4-uVPBD {
	margin-bottom: 24px !important;
}

.ReportManagement-space5-xgfe9 {
	margin-bottom: 30px !important;
}

.ReportManagement-space6-RFD3m {
	margin-bottom: 36px !important;
}

.ReportManagement-space7-KM15m {
	margin-bottom: 42px !important;
}

.ReportManagement-space8-ySuLp {
	margin-bottom: 48px !important;
}

.ReportManagement-spaceTop1-fNwwo {
	margin-top: 6px !important;
}

.ReportManagement-spaceTop2-iUvGT {
	margin-top: 12px !important;
}

.ReportManagement-spaceTop3-QxkIf {
	margin-top: 18px !important;
}

.ReportManagement-spaceTop4-OGhnJ {
	margin-top: 24px !important;
}

.ReportManagement-spaceTop5-sxcHt {
	margin-top: 30px !important;
}

.ReportManagement-spaceTop6-LyxDs {
	margin-top: 36px !important;
}

.ReportManagement-spaceTop7-Ds9mv {
	margin-top: 42px !important;
}

.ReportManagement-spaceTop8-ppvby {
	margin-top: 48px !important;
}

.ReportManagement-noMargin-jD3gK {
	margin: 0px !important;
}

.ReportManagement-padding1-VSCzm {
	padding-bottom: 6px !important;
}

.ReportManagement-padding2-TKRwc {
	padding-bottom: 12px !important;
}

.ReportManagement-padding3-yZtaI {
	padding-bottom: 18px !important;
}

.ReportManagement-padding4-BOkDQ {
	padding-bottom: 24px !important;
}

.ReportManagement-padding5-iaUUE {
	padding-bottom: 30px !important;
}

.ReportManagement-padding6-zVb7H {
	padding-bottom: 36px !important;
}

.ReportManagement-padding7-YHfo1 {
	padding-bottom: 42px !important;
}

.ReportManagement-paddingTop1-VbFNr {
	padding-top: 6px !important;
}

.ReportManagement-paddingTop2-LrQ3L {
	padding-top: 12px !important;
}

.ReportManagement-paddingTop3-pHVTQ {
	padding-top: 18px !important;
}

.ReportManagement-paddingTop4-OP9Pw {
	padding-top: 24px !important;
}

.ReportManagement-paddingTop5-sO0ob {
	padding-top: 30px !important;
}

.ReportManagement-paddingTop6-eHgcl {
	padding-top: 36px !important;
}

.ReportManagement-paddingTop7-uZn7H {
	padding-top: 42px !important;
}

.ReportManagement-noPadding-gJicD {
	padding: 0px !important;
}

.ReportManagement-spaceMarginBottom0-wamAT {
	margin-bottom: 0;
}

.ReportManagement-textBold-yqA5l {
	font-weight: 500 !important;
}

.ReportManagement-textBolder-S2nGt {
	font-weight: 700 !important;
}

.ReportManagement-textNormal-AZmL5 {
	font-weight: normal !important;
}

/*New Design Text Colors */

.ReportManagement-textDarkBlue-zHRms {
	color: rgb(20, 39, 94) !important;
}

.ReportManagement-textLightBlue-DqZ4U {
	color: rgb(57, 87, 106) !important;
}

.ReportManagement-textLightSandleGreen-pGSLD {
	color: rgb(76, 86, 41) !important;
}

.ReportManagement-textLightBrown-R3mZM {
	color: rgb(115, 79, 33) !important;
}

.ReportManagement-textMediumMaroon-n3hVz {
	color: rgb(87, 37, 51) !important;
}

.ReportManagement-textBrown-uOx4r {
	color: rgb(160, 47, 24) !important;
}

.ReportManagement-textMaroon-BwM1u {
	color: rgb(155, 49, 67) !important;
}

.ReportManagement-textDarkBrown-ihSip {
	color: rgb(83, 18, 16) !important;
}

.ReportManagement-textMediumBrown-jwlj9 {
	color: rgb(142, 28, 10) !important;
}

.ReportManagement-textSkyBlue-W6PAU {
	color: rgb(37, 117, 141) !important;
}

.ReportManagement-textGray-GhUNN {
	color: rgb(77, 65, 51) !important;
}

.ReportManagement-errorMessage-sSmNZ {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.ReportManagement-userText-f7wgC {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.ReportManagement-panelHeader-HJEo9 {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.ReportManagement-exportSection-mvjoM {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.ReportManagement-exportSectionGridSub-zCbhr {
	grid-template-columns: 50% 49% !important;
}

.ReportManagement-exportText-TnJZB {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.ReportManagement-exportLinkImg-NVUmf {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.ReportManagement-exportImg-HKx9I {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ReportManagement-linkBtn-HPtHv {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.ReportManagement-table-oWsK3 {
	display: table;
}

.ReportManagement-tableRow-Wy10a {
	display: table-row;
}

.ReportManagement-tableCell-rIbjX {
	display: table-cell;
	float: none;
}

.ReportManagement-formGroup-Q7pAs {
	margin-bottom: 6px;
}

.ReportManagement-marginTop0-IEZxs {
	margin-top: 0;
}

.ReportManagement-marginBottom20-_rgKc {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.ReportManagement-bannerImageBg-d5QhT {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.ReportManagement-bannerDelete-TNjbs {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.ReportManagement-exportLink-WABgJ {
	padding-top: 10px;
	padding-right: 10px;
}

.ReportManagement-seachContent-FcHHN {
	padding-left: 0px;
	margin-bottom: 5px;
}

.ReportManagement-marginBottom9-ar34v {
	margin-bottom: 9px;
}

.ReportManagement-spaceTop52-oN0im {
	margin-top: 52px;
}

.ReportManagement-profileViewInner-gBLKw {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.ReportManagement-profileViewMain-NVQ_t {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.ReportManagement-profileViewlabel-kwW3k {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.ReportManagement-profileViewMainContent-BGvqy {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.ReportManagement-reviewsFormStar-IrXJD {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.ReportManagement-reviewsFormStar-IrXJD svg {
	cursor: pointer;
}

.ReportManagement-addLanguageText-iFGtF {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.ReportManagement-exportSection-mvjoM {
		grid-template-columns: 100%;
	}

	.ReportManagement-spaceTop52-oN0im {
		margin-top: 18px;
	}

	.ReportManagement-exportText-TnJZB {
		float: none;
		margin-top: 12px;
	}

	.ReportManagement-exportSectionGridSub-zCbhr {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.ReportManagement-profileViewlabel-kwW3k {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ReportManagement-profileViewMainContent-BGvqy {
		width: 100%;
		text-align: center;
	}

	.ReportManagement-panelHeader-HJEo9 {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ReportManagement-space1-CLnGJ`,
	"space2": `ReportManagement-space2-etRMk`,
	"space3": `ReportManagement-space3-Ly973`,
	"space4": `ReportManagement-space4-uVPBD`,
	"space5": `ReportManagement-space5-xgfe9`,
	"space6": `ReportManagement-space6-RFD3m`,
	"space7": `ReportManagement-space7-KM15m`,
	"space8": `ReportManagement-space8-ySuLp`,
	"spaceTop1": `ReportManagement-spaceTop1-fNwwo`,
	"spaceTop2": `ReportManagement-spaceTop2-iUvGT`,
	"spaceTop3": `ReportManagement-spaceTop3-QxkIf`,
	"spaceTop4": `ReportManagement-spaceTop4-OGhnJ`,
	"spaceTop5": `ReportManagement-spaceTop5-sxcHt`,
	"spaceTop6": `ReportManagement-spaceTop6-LyxDs`,
	"spaceTop7": `ReportManagement-spaceTop7-Ds9mv`,
	"spaceTop8": `ReportManagement-spaceTop8-ppvby`,
	"noMargin": `ReportManagement-noMargin-jD3gK`,
	"padding1": `ReportManagement-padding1-VSCzm`,
	"padding2": `ReportManagement-padding2-TKRwc`,
	"padding3": `ReportManagement-padding3-yZtaI`,
	"padding4": `ReportManagement-padding4-BOkDQ`,
	"padding5": `ReportManagement-padding5-iaUUE`,
	"padding6": `ReportManagement-padding6-zVb7H`,
	"padding7": `ReportManagement-padding7-YHfo1`,
	"paddingTop1": `ReportManagement-paddingTop1-VbFNr`,
	"paddingTop2": `ReportManagement-paddingTop2-LrQ3L`,
	"paddingTop3": `ReportManagement-paddingTop3-pHVTQ`,
	"paddingTop4": `ReportManagement-paddingTop4-OP9Pw`,
	"paddingTop5": `ReportManagement-paddingTop5-sO0ob`,
	"paddingTop6": `ReportManagement-paddingTop6-eHgcl`,
	"paddingTop7": `ReportManagement-paddingTop7-uZn7H`,
	"noPadding": `ReportManagement-noPadding-gJicD`,
	"spaceMarginBottom0": `ReportManagement-spaceMarginBottom0-wamAT`,
	"textBold": `ReportManagement-textBold-yqA5l`,
	"textBolder": `ReportManagement-textBolder-S2nGt`,
	"textNormal": `ReportManagement-textNormal-AZmL5`,
	"textDarkBlue": `ReportManagement-textDarkBlue-zHRms`,
	"textLightBlue": `ReportManagement-textLightBlue-DqZ4U`,
	"textLightSandleGreen": `ReportManagement-textLightSandleGreen-pGSLD`,
	"textLightBrown": `ReportManagement-textLightBrown-R3mZM`,
	"textMediumMaroon": `ReportManagement-textMediumMaroon-n3hVz`,
	"textBrown": `ReportManagement-textBrown-uOx4r`,
	"textMaroon": `ReportManagement-textMaroon-BwM1u`,
	"textDarkBrown": `ReportManagement-textDarkBrown-ihSip`,
	"textMediumBrown": `ReportManagement-textMediumBrown-jwlj9`,
	"textSkyBlue": `ReportManagement-textSkyBlue-W6PAU`,
	"textGray": `ReportManagement-textGray-GhUNN`,
	"errorMessage": `ReportManagement-errorMessage-sSmNZ`,
	"userText": `ReportManagement-userText-f7wgC`,
	"panelHeader": `ReportManagement-panelHeader-HJEo9`,
	"exportSection": `ReportManagement-exportSection-mvjoM`,
	"exportSectionGridSub": `ReportManagement-exportSectionGridSub-zCbhr`,
	"exportText": `ReportManagement-exportText-TnJZB`,
	"exportLinkImg": `ReportManagement-exportLinkImg-NVUmf`,
	"exportImg": `ReportManagement-exportImg-HKx9I`,
	"linkBtn": `ReportManagement-linkBtn-HPtHv`,
	"table": `ReportManagement-table-oWsK3`,
	"tableRow": `ReportManagement-tableRow-Wy10a`,
	"tableCell": `ReportManagement-tableCell-rIbjX`,
	"formGroup": `ReportManagement-formGroup-Q7pAs`,
	"marginTop0": `ReportManagement-marginTop0-IEZxs`,
	"marginBottom20": `ReportManagement-marginBottom20-_rgKc`,
	"bannerImageBg": `ReportManagement-bannerImageBg-d5QhT`,
	"bannerDelete": `ReportManagement-bannerDelete-TNjbs`,
	"exportLink": `ReportManagement-exportLink-WABgJ`,
	"seachContent": `ReportManagement-seachContent-FcHHN`,
	"marginBottom9": `ReportManagement-marginBottom9-ar34v`,
	"spaceTop52": `ReportManagement-spaceTop52-oN0im`,
	"profileViewInner": `ReportManagement-profileViewInner-gBLKw`,
	"profileViewMain": `ReportManagement-profileViewMain-NVQ_t`,
	"profileViewlabel": `ReportManagement-profileViewlabel-kwW3k`,
	"profileViewMainContent": `ReportManagement-profileViewMainContent-BGvqy`,
	"reviewsFormStar": `ReportManagement-reviewsFormStar-IrXJD`,
	"addLanguageText": `ReportManagement-addLanguageText-iFGtF`
};
module.exports = ___CSS_LOADER_EXPORT___;
